<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="4">
        <CCard>
          <CCardHeader>
            <i class="fa fa-filter"></i>&nbsp; Filtrar por
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12">
                <cSelectForm
                  label="Seleccione una Sede"
                  :options="campus"
                  placeholder="Escoja una Sede"
                  :value.sync="filter.campu"
                  @change="mtdLoadData"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="8" lg="12" xl="12" xxl="8" xs="8" sm="8">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Almacenes"
          icon="fas fa-coins"
          btn_name="Almacén"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="false"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <cSelect
            :options="cpCampus"
            label="Sede"
            :value="almacen.campu_id"
            @input="almacen.campu_id = $event.target.value"
            :disabled="modal.action == 'update'"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="almacen.name"
          />
        </CCol>
        <!-- <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="almacen.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol> -->
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Almacén'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campu", label: "Sede", _style: "width:20%;" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../../main";
// import CSwitchVue from "../../shared/switch/CSwitch.vue";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    // CSwitchVue,
    cSelectForm
  },
  data() {
    return {
      prefix: "almacenes",
      fields,
      data: [],
      allData:[],
      campus:[],
      filter: {
        campu: 0,
      },
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      almacen: {
        id: "",
        campu_id: "",
        campu_name: "",
        name: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      // dataStore: [],
    };
  },
  computed: {    
    btnClasses() {
      return [`btn text-white w-100`];
    },
    cpCampus(){
      return this.campus.filter( (item)=> item.value != 0);
    },
    cpStatus: function () {
      if (this.almacen.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.almacen.name != "") return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.mtd_getcampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getcampus: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/campus/index",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.campus = [
          { value: 0, label: 'TODAS LAS SEDES' },
          ...response.data.all.map(item => ({
            label: item.name,
            value: item.id
          }))
        ];
      });
    },
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index",
        token: this.$store.getters.get__token,
      }).then((response) => {
        this.allData = response.data.data;
        let index = 1;
        this.allData.forEach((arr) => {
          arr.index = index;
          index++;
        });
        this.data=this.allData;
      });
    },
    mtdLoadData: function(){
      const campu = this.filter.campu;
      if (campu == 0) {
        this.data =this.allData;
      } else {
        this.data = this.allData.filter((item)=> item.campu_id == campu )
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Almacen")
        : (this.modal.title = "Editar Almacen");
      action == "store"
        ? (this.almacen = {
            id: "",
            campu_id: "",
            campu_name: "",
            name: "",
            state: "",
          })
        : (this.almacen = { ...this.almacen });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.almacen,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Almacén ya resgistrado",
              icon: "warning",
            });
          } else if (response.statusCode == 200) {
            const color = "success";
            const message =
              this.modal.action == "store"
                ? "REGISTRADO CORRECTAMENTE"
                : "EDITADO CORRECTAMENTE";
            if (this.modal.action == "store") {
              this.mtd_getdata();
            } else {
              this.data = this.data.map((element) =>
                element.Id === response.data.data[0].Id
                  ? { ...element, ...response.data.data[0] }
                  : element
              );
              this.componentKey += 1; // Forzar re-renderización
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };

            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          bus.$emit("alert", {
            color: "danger",
            message: errors,
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          id +
          "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.almacen = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.almacen.state = payload == true ? 1 : 0;
    },
  },
  destroyed() {
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
